import { requireDashboardOrigin } from "@api/features/dashboard-auth/origin/dashboardOriginGuard"
import { requireDashboardAuth } from "@api/features/dashboard-auth/session/requireDashboardAuth"
import { serverRouteConfig } from "@server/server-route-config"
import { dashboardApiErrorMessage } from "@site-server/dashboard-api-errors"
import { createFileRoute } from "@tanstack/react-router"
import * as z from "zod"

const updateDashboardProfileLanguageInputSchema = z.object({
  dashboardLanguage: z.enum(["en", "ja"]),
})

export const Route = createFileRoute("/api/dashboard/profile/language")(
  serverRouteConfig({
    server: {
      handlers: {
        POST: async ({ request }) => {
          const originError = requireDashboardOrigin(request)
          if (originError) return originError

          try {
            const input = updateDashboardProfileLanguageInputSchema.parse(await request.json())
            const auth = await requireDashboardAuth(request, [])
            if ("response" in auth) return auth.response

            const { updateCurrentDashboardProfileLanguage } = await import(
              "@api/features/dashboard-profile/dashboardProfile"
            )
            return Response.json(
              await updateCurrentDashboardProfileLanguage({
                dashboardLanguage: input.dashboardLanguage,
                user: auth.user,
              })
            )
          } catch (error) {
            return Response.json(
              { error: dashboardApiErrorMessage(error, "Could not save language.") },
              { status: 400 }
            )
          }
        },
      },
    },
  })
)
